import React, { Component } from "react";
import Slider from "react-slick";
import "../../assets/style.css";
const OPTION_KEYS = ["navigation", "pagination", "scrollBar", "loop"];

export default class Demo extends Component {
  constructor() {
    super();

    this.decrement = this.decrement.bind(this);
    this.increment = this.increment.bind(this);
    this.state = {
      slideCount: 5,
      settings: {
        dots: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    };
  }

  increment(e) {
    e.preventDefault();
    this.setState({ slideCount: this.state.slideCount + 1 });
  }

  decrement(e) {
    e.preventDefault();
    this.setState({ slideCount: this.state.slideCount - 1 });
  }

  toggleOption(prop) {
    this.setState({
      options: Object.assign({}, this.state.options, {
        [prop]: !this.state.options[prop]
      })
    });
  }

  render() {
    return (
      <div className="Demo">
        <div className="Demo-swiper">
          <div className="row">
            <div className="col-md-12">
              <Slider {...this.state.settings}>
                {this.props.slides.map(res => (
                  <div className="container pic-cont">
                    <img
                      style={{
                        margin: "auto",
                        width: "400px"
                      }}
                      src={res}
                      alt="shani"
                    />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="col-md-3"></div>
          </div>
        </div>
      </div>
    );
  }
}
